import React, { ComponentType, PureComponent } from 'react';
import { CardFormMetricsContext } from 'services/CardFormMetricsContext';

const withCardFormMetrics = <P extends object>(Component: ComponentType<P>) => {
  class WithCardFormMetrics extends PureComponent<P> {
    render() {
      return (
        <CardFormMetricsContext.Consumer>
          {value => <Component {...this.props} {...value} />}
        </CardFormMetricsContext.Consumer>
      );
    }
  }

  return WithCardFormMetrics;
};

export default withCardFormMetrics;
